import { createQueryKeys } from '@lukemorales/query-key-factory';

import { calculateContractPackagePrices, ContractPackagePriceRequestMessage } from '../clients/packagePrice.api';

export const packagePrices = createQueryKeys('packagePrices', {
    contractPrices: (contractPackagePricesRequest: ContractPackagePriceRequestMessage[], deliveryDate?: string) => ({
        queryKey: [{ contractPackagePricesRequest, deliveryDate }],
        queryFn: () => calculateContractPackagePrices(contractPackagePricesRequest, deliveryDate),
    }),
});
